export const appNums = {
    MIN_PASSWORD_LENGTH: 8,
    MIN_ONBOARDING_TEAM_FIELDS: 3,
    DEFAULT_VIDEO_WIDTH: 522,
}



// WEBPACK FOOTER //
// ./src/common/nums/app_nums.js